import { Component, Input } from '@angular/core';
import { Game } from '@mtgame/core';
import { getGameRoute } from '@config/routes';
import { getTournamentShortName, getTourTitle } from '@utils/hardcode';

@Component({
  selector: 'mtg-game-card',
  templateUrl: './game-card.component.html',
  styleUrls: ['./game-card.component.scss']
})
export class GameCardComponent {
  @Input() game: Game;
  @Input() showTournament: boolean;

  get tournamentName(): string {
    return getTournamentShortName(this.game.tournament.name);
  }

  get gameRoute(): string[] {
    return getGameRoute(this.game.id);
  }

  getTourTitle(tour: number): string {
    return getTourTitle(tour, this.game.team.sport, true);
  }
}
